export const EMPTY_QDF_ASSET_CONFIG = {
  groupedAssetTags: [],
  assetNumbers: [],
  assetNumberByTag: {},
  assetTagByNumber: {},
  assetTagDetails: {},
  locations: [],
  zones: [],
  departments: [],
};

export const buildQDFAssetConfigFromShops = (shops = []) => {
  const groupedMap = new Map();
  const assetTagDetails = {};
  const assetNumberByTag = {};
  const assetTagByNumber = {};
  const allAssetTags = [];

  for (const shop of shops) {
    const label = (shop.shopLabel || '').trim();
    const assetTag = (shop.assetTag || '').trim();
    const assetNumber = (shop.assetNumber || '').trim();
    const location = (shop.location || '').trim();
    const zone = (shop.zone || '').trim();
    const department = (shop.department || '').trim();

    if (!label || !assetTag || !assetNumber) {
      continue;
    }

    if (!groupedMap.has(label)) {
      groupedMap.set(label, []);
    }

    groupedMap.get(label).push(assetTag);
    allAssetTags.push(assetTag);
    assetTagDetails[assetTag] = { location, zone, department };
    assetNumberByTag[assetTag] = assetNumber;
    assetTagByNumber[assetNumber] = assetTag;
  }

  const groupedAssetTags = Array.from(groupedMap.entries()).map(([label, options]) => ({
    label,
    options,
  }));

  const assetNumbers = allAssetTags.map((tag) => assetNumberByTag[tag]);

  const locationSet = new Set();
  const zoneSet = new Set();
  const departmentSet = new Set();

  for (const details of Object.values(assetTagDetails)) {
    if (details.location) {
      locationSet.add(details.location);
    }
    if (details.zone) {
      zoneSet.add(details.zone);
    }
    if (details.department) {
      departmentSet.add(details.department);
    }
  }

  return {
    groupedAssetTags,
    assetNumbers,
    assetNumberByTag,
    assetTagByNumber,
    assetTagDetails,
    locations: Array.from(locationSet),
    zones: Array.from(zoneSet),
    departments: Array.from(departmentSet),
  };
};
